// Telefon kuralı — TEK KAYNAK (client + server).
// validate.ts (checkout/adres), contact.ts (iletişim) ve CheckoutForm.tsx
// (HTML pattern) buradan beslenir; kural değişince hepsi birlikte değişir.
//
// Kural: en fazla 20 karakter, izinli alfabe `[0-9+ boşluk ()]` ve EN AZ 7 rakam
// (lookahead). "+++++++"/boşluk-only girdiler geçemez. Bilinçli olarak GSM-only
// DEĞİLDİR (yabancı numaralar checkout'u geçebilir); WhatsApp bildirimi için
// ayrıca `normalizeTRPhone` (whatsapp.ts) GSM kontrolü yapar.
export const PHONE_RE = /^(?=(?:[^0-9]*[0-9]){7,})[0-9+\s()]{7,20}$/;

/**
 * HTML `pattern` niteliği için aynı kural (pattern zaten baştan-sona eşleşir,
 * bu yüzden `^...$` çapaları sökülür). `new RegExp(`^(?:${s})$`)` === PHONE_RE.
 */
export const PHONE_INPUT_PATTERN = "(?=(?:[^0-9]*[0-9]){7,})[0-9+ ()]{7,20}";

export function isValidPhone(raw: string | null | undefined): boolean {
  return PHONE_RE.test((raw ?? "").trim());
}
